module.exports = '<svg viewBox="0 0 32 16"><path d="M9.1.7H8c-.5 0-.8.3-.8.7v13.3c0 .3.4.6.8.6h1.2c.5 0 .8-.3.8-.6V1.5c0-.4-.4-.8-.9-.8zM29.6.7h-2.7c-.5 0-.8.3-.8.8v13.1c0 .4.4.7.8.7h2.7c.5 0 .8-.3.8-.7V1.5c.1-.4-.3-.8-.8-.8zM15.3.7h-2.7c-.5 0-.8.3-.8.8v13.1c0 .4.4.7.8.7h2.7c.5 0 .8-.3.8-.7V1.5c.1-.4-.3-.8-.8-.8zM4.5.7H2.2c-.4 0-.7.3-.7.8v13.1c0 .4.3.7.7.7h2.3c.4 0 .7-.3.7-.7V1.5c0-.4-.3-.8-.7-.8zM23.3.7h-.5c-.4 0-.8.3-.8.6v13.2c0 .4.4.7.8.7h.5c.5 0 .8-.3.8-.7V1.3c.1-.3-.3-.6-.8-.6zM19.4.7h-.5c-.5 0-.8.3-.8.6v13.3c0 .3.4.6.8.6h.5c.5 0 .8-.3.8-.6V1.3c0-.3-.4-.6-.8-.6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/label-insight-bar-code.js
// module id = 1203
// module chunks = 14